import {gql} from "@apollo/client";

export const GQL_SERVICE_VARIABLES_GROUP_BY_CREDENTIAL_ID_QUERY = gql`
  query serviceVariableByCredentialId($service_id: Int!) {
    response: serviceVariableByCredentialId(service_id: $service_id) {
      data {
        credential {
          id
          account
          credential_type
          display_name
          description
          hint
          username
          version
          used_secret_properties
        }
        service_variables {
          id
          account
          service
          credential {
            id
            account
            credential_type
            display_name
            description
            hint
            username
            version
            used_secret_properties
          }
          variable_name
          property_name
        }
      }
    }
  }
`;

export const GQL_SERVICE_VARIABLES_CREATE_MULTIPLE = gql`
  mutation CreateServiceVariables($input: CreateServiceVariables!) {
    response: createServiceVariables(input: $input) {
      ... on GenericMutationResponseSuccess {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_SERVICE_VARIABLES_UPDATE = gql`
  mutation UpdateServiceVariable($id: ID!, $input: UpdateServiceVariable!) {
    response: updateServiceVariable(id: $id, input: $input) {
      ... on ServiceVariableMutationSuccess {
        status
        data {
          id
          account
          service
          credential {
            id
          }
          variable_name
          property_name
        }
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;

export const GQL_SERVICE_VARIABLES_DELETE = gql`
  mutation DeleteServiceVariables($ids: [Int!]!) {
    response: deleteServiceVariables(ids: $ids) {
      ... on GenericMutationResponseSuccess {
        status
      }
      ... on ErrorResponse {
        status
        message
      }
    }
  }
`;
